import React from 'react';
import { useNavigate } from 'react-router-dom';

const LandingFooter = ({ isDarkMode, onScrollToSection }) => {
  const navigate = useNavigate();

  return (
    <footer className={`py-12 ${isDarkMode ? 'bg-[#0B0F17] border-t border-slate-800' : 'bg-slate-900'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="AIQuizPark" className="w-8 h-8 rounded-lg" />
            <span className="text-white font-bold font-['Outfit']">AIQuizPark</span>
          </div>
          <div className="flex flex-wrap justify-center gap-6">
            <button onClick={() => onScrollToSection('students-section')} className="text-slate-400 hover:text-white text-sm transition-colors">Students</button>
            <button onClick={() => onScrollToSection('teachers-section')} className="text-slate-400 hover:text-white text-sm transition-colors">Teachers</button>
            <button onClick={() => navigate('/pricing')} className="text-slate-400 hover:text-white text-sm transition-colors">Pricing</button>
            <button onClick={() => navigate('/login')} className="text-slate-400 hover:text-white text-sm transition-colors">Login</button>
          </div>
          <p className="text-slate-500 text-sm">
            © 2024 AIQuizPark. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
